import { Module, Payload } from 'vuex';
import { RootStoreState } from '@/store';
import { AffiliateGroupsResponse, AllUsersListTypeContent, PartyGroupPermissionSection, ScopeProductGroup, ScopeUserGroupResponseContent, UserGroup } from '@/modules/msw-products/types';

export interface UserGroupStoreState {
  selectedUserGroup: any;
  hoveredUserGroup: any;
  addUserFlag: boolean;
  initialSelectedList: [];
  userGroupResponseCopy: any[];

  defaultProductGroupId: string;
  defaultUserGroup: {} | null;
  selectedUserGroupDetail: any[];
  userGroups: UserGroup[];
  affiliateGroups: AffiliateGroupsResponse[];

  tenantsForUserGroup: ScopeUserGroupResponseContent | null;
  usersForUserGroup: AllUsersListTypeContent | null;
  permissionsForUserGroup: PartyGroupPermissionSection[];
  loadingTenantsForUserGroup: boolean;
  loadingUsersForUserGroup: boolean;
  loadingPermissionsForUserGroup: boolean;
  showAssignTenantModal: boolean;
}

export interface StoreUserGroupManagement extends Partial<Payload> {
  selectedUserGroup: any;
  hoveredUserGroup: UserGroupStoreState['hoveredUserGroup'];
}

export const MUTATION_SELECT_USER_GROUP = 'userGroupSelected';
export const MUTATION_HOVER_USER_GROUP = 'userGroupHovered';

export default {
  state: {
    selectedUserGroup: [],
    registerProductView: false,
    hoveredUserGroup: [],
    addUserFlag: false,
    initialSelectedList: [],
    userGroupResponseCopy: [],

    defaultProductGroupId: '',
    defaultUserGroup: '',
    selectedUserGroupDetail: [],
    userGroups: [],
    affiliateGroups: [],
    tenantsForUserGroup: null,
    usersForUserGroup: null,
    permissionsForUserGroup: [],
    loadingTenantsForUserGroup: false,
    loadingUsersForUserGroup: false,
    loadingPermissionsForUserGroup: false,
    showAssignTenantModal: false,
  },
    /*tslint:disable:function-name */
  mutations: {
    [MUTATION_SELECT_USER_GROUP](state, payload) {
      state.selectedUserGroup = payload;
    },
    [MUTATION_HOVER_USER_GROUP](state, payload) {
      state.hoveredUserGroup = payload;
    },
    mutate: (state:any , payload) => state[payload.property] = payload.with,
    setUserGroupResponseCopy(state: any, payload) {
      state.userGroupResponseCopy = JSON.parse(JSON.stringify(payload));
    },

    setDefaultProductGroupId: (state: any, payload: string) => state.defaultProductGroupId = payload,
    setDefaultUserGroup: (state: any, payload: string) => state.defaultUserGroup = payload,
    setSelectedUserGroupDetail: (state: any, payload: string) => state.selectedUserGroupDetail = payload,
    setUserGroups: (state: UserGroupStoreState, payload) => state.userGroups = payload,
    setAffiliateGroups: (state: UserGroupStoreState, payload) => state.affiliateGroups = payload,
    setTenantsForUserGroup: ((state: UserGroupStoreState, payload: ScopeUserGroupResponseContent) => {
      const { assignedProductGroup, availbleProductGroup } = payload || {};
      state.tenantsForUserGroup = payload;
      assignedProductGroup?.sort((a: any, b: any) => {
        return a?.productGroupId?.localeCompare(b?.productGroupId);
      });
      availbleProductGroup?.sort((a: any, b: any) => {
        return a?.productGroupId?.localeCompare(b?.productGroupId);
      });
    }),
    setUsersForUserGroup: (state: UserGroupStoreState, payload: AllUsersListTypeContent) => state.usersForUserGroup = payload,
    setPermissionsForUserGroup: (state: UserGroupStoreState, payload: PartyGroupPermissionSection[]) => state.permissionsForUserGroup = payload,
    setLoadingTenantsForUserGroup: ((state: UserGroupStoreState, payload: boolean) => {
      state.loadingTenantsForUserGroup = payload;
    }),
    setLoadingUsersForUserGroup: (state: UserGroupStoreState, payload: boolean) => state.loadingUsersForUserGroup = payload,
    setLoadingPermissionsForUserGroup: (state: UserGroupStoreState, payload: boolean) => state.loadingPermissionsForUserGroup = payload,
    updateUserGroup(state: UserGroupStoreState, updatedGroup: UserGroup) {
      const selectedUserGroupIndex = state.userGroups?.findIndex((ug: UserGroup) => ug?.partyGroupId === updatedGroup?.partyGroupId);
      if (selectedUserGroupIndex !== -1) state.userGroups.splice(selectedUserGroupIndex, 1, updatedGroup);
    },
    setShowAssignTenantModal: (state: UserGroupStoreState, payload: boolean) => state.showAssignTenantModal = payload,
    updateTenantsForUserGroup(state: UserGroupStoreState, selectedTenant: ScopeProductGroup) {
      const { assignedProductGroup, availbleProductGroup: availableProductGroup } = state.tenantsForUserGroup as ScopeUserGroupResponseContent || {};
      const selectedTenantIndex = assignedProductGroup?.findIndex((tenant: ScopeProductGroup) => tenant?.productGroupId === selectedTenant?.productGroupId);
      assignedProductGroup.splice(selectedTenantIndex, 1);
      availableProductGroup.unshift(selectedTenant);
      availableProductGroup?.sort((a: any, b: any) => {
        return a?.productGroupId?.localeCompare(b?.productGroupId);
      });
    },
  },
  getters: {
    getSelectedUserGroup(state: any) {
      return state.selectedUserGroup;
    },
    getHoveredUserGroup(state: any) {
      return state.hoveredUserGroup;
    },
    getAddUserFlagState(state: any) {
      return state.addUserFlag;
    },
    getInitialCustomersList: state => state.initialSelectedList,
    getAffiliateGroupArray: state => state.affiliateGroups,
    getUserGroupResponseCopy: state => state.userGroupResponseCopy,
    // Asf
    getDefaultProductGroupId: state => state.defaultProductGroupId,
    getDefaultUserGroup: state => state.defaultUserGroup,
    getSelectedUserGroupDetail: state => state.selectedUserGroupDetail,
    // getSelectedUserGroupId: state => state.selectedUserGroupId,
    getUserGroups: state => state.userGroups,
    getAffiliateGroups: state => state.affiliateGroups,

    getTenantsForUserGroup: state => state.tenantsForUserGroup,
    getUsersForUserGroup: state => state.usersForUserGroup,
    getPermissionsForUserGroup: state => state.permissionsForUserGroup,
    getLoadingTenantsForUserGroup: state => state.loadingTenantsForUserGroup,
    getLoadingUsersForUserGroup: state => state.loadingUsersForUserGroup,
    getLoadingPermissionsForUserGroup: state => state.loadingPermissionsForUserGroup,
    getShowAssignTenantModal: state => state.showAssignTenantModal,
  },
  actions: {
    userGroupSelected({ commit }, payload) {
      commit(MUTATION_SELECT_USER_GROUP, payload);
    },
    userGroupHovered({ commit }, payload) {
      commit(MUTATION_HOVER_USER_GROUP, payload);
    },
  },
  namespaced: true,
    /*tslint:enable:function-name */
} as Module<UserGroupStoreState, RootStoreState>;
